document.addEventListener('DOMContentLoaded', function(){
  const form = document.querySelector('form.search-bar');
  const wrapper = form?.querySelector('.search-bar__wrapper');
  if(!form || !wrapper) return;

  // buat loader kalau belum ada
  let loader = wrapper.querySelector('.search-bar__loading');
  if(!loader){
    loader = document.createElement('div');
    loader.className = 'search-bar__loading';
    loader.setAttribute('aria-hidden','true');
    loader.innerHTML = '<span class="search-spinner" aria-hidden="true"></span><span class="loading-text">Searching…</span>';
    wrapper.insertBefore(loader, wrapper.firstChild);
  }

  // hanya CSS yang toggle via class is-loading, jadi ga perlu JS tambahan
});

(function () {
  function bindHistoryToLoading({
    formSel    = 'form.search-bar',
    inputSel   = '.search-bar__input',
    historySel = '.custom-search_history'
  } = {}) {
    const form   = document.querySelector(formSel);
    if (!form) return;

    const input  = form.querySelector(inputSel);
    const hist   = form.querySelector(historySel);
    if (!hist) return;

    const hide = () => { hist.style.display = 'none'; };
    const show = () => { hist.style.removeProperty('display'); };

    const update = () => {
      // kalau input kosong, jangan tampilkan history
      if (!input || input.value.trim() === '') return hide();

      // saat loading ketik (is-loading) => sembunyi
      if (form.classList.contains('is-loading')) return hide();

      // loading selesai => tampilkan kembali
      show();
    };

    // pantau perubahan class pada form (is-loading on/off)
    const mo = new MutationObserver(update);
    mo.observe(form, { attributes: true, attributeFilter: ['class'] });

    // sinkron juga saat user ketik/focus/blur
    if (input) {
      input.addEventListener('input', update);
      input.addEventListener('focus', update);
      input.addEventListener('blur', () => setTimeout(update, 150));
    }

    // inisialisasi
    update();
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindHistoryToLoading();
  });
})();


document
  .querySelector('.header__search-bar-wrapper form.search-bar')
  .addEventListener('submit', function (event) {
    event.preventDefault();
    const input = document.querySelector('.header__search-bar-wrapper form.search-bar input[name="q"]');
    let term = (input.value || '').trim();
    if (!term) return this.submit();

    const MAX = 6;
    let arr = JSON.parse(localStorage.getItem('searchHistory')) || [];

    const idx = arr.findIndex(t => (t || '').toLowerCase() === term.toLowerCase());
    if (idx > -1) arr.splice(idx, 1);
    arr.unshift(term);

    if (arr.length > MAX) arr = arr.slice(0, MAX);

    localStorage.setItem('searchHistory', JSON.stringify(arr));
    this.submit();
  });

// load search history from localStorage
document.addEventListener('DOMContentLoaded', function () {
  const history = JSON.parse(localStorage.getItem('searchHistory')) || [];
  // const c1 = document.querySelector('.custom-search_history__list');
  const c2 = document.querySelector('.custom-search_history__list-2');
  if (!c2) return;

  function render(container) {
    container.innerHTML = '';
    const iconHTML = container.dataset.iconHtml || '';
    history.forEach(term => {
      const item = document.createElement('div');
      item.className = 'search-bar__history-item';
      item.dataset.term = term;
      item.innerHTML = `
        <div class="tw-flex tw-items-center" style="gap: 6px;">
          <div class="history-icon" aria-hidden="true">${iconHTML}</div>
          <div class="term">${term}</div>
        </div>
        <button type="button" class="search-bar__history-delete" aria-label="Remove">
          <svg width="10" height="10" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.4 14L0 12.6L5.6 7L0 1.4L1.4 0L7 5.6L12.6 0L14 1.4L8.4 7L14 12.6L12.6 14L7 8.4L1.4 14Z" fill="#b2b2b2"/>
          </svg>
        </button>`;
      container.appendChild(item);
    });
  }

  // render(c1);
  render(c2);

  function wire(container) {
    container.addEventListener('click', (e) => {
      const delBtn = e.target.closest('.search-bar__history-delete');
      const item   = e.target.closest('.search-bar__history-item');
      if (!item) return;

      const term = item.dataset.term;

      if (delBtn) {
        e.stopPropagation();
        const arr = JSON.parse(localStorage.getItem('searchHistory')) || [];
        const i = arr.indexOf(term);
        if (i > -1) {
          arr.splice(i, 1);
          localStorage.setItem('searchHistory', JSON.stringify(arr));
        }
        item.remove();
        document
          .querySelectorAll(`.search-bar__history-item[data-term="${CSS.escape(term)}"]`)
          .forEach(el => el.remove());
        return;
      }

      document.querySelector('.header__search-bar-wrapper form.search-bar input[name="q"]').value = term;
      document.querySelector('.header__search-bar-wrapper form.search-bar').submit();
    });
  }

  // wire(c1);
  wire(c2);
});


document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.querySelector('.search-bar__input');
  const historyContainer = document.querySelector('.search-bar__inner-2');
  const campaignButton = document.querySelector('.custom-floating-campaign');
  const mobileNav = document.querySelector('.mobile-navbar');

  if (!searchInput || !historyContainer) return;

  historyContainer.style.display = 'none';
  let clickingDelete = false; 

  // Saat mouse down di tombol X, jangan sampai input blur & set flag
  historyContainer.addEventListener('mousedown', (e) => {
    if (e.target.closest('.search-bar__history-delete')) {
      clickingDelete = true;
      e.preventDefault();
    }
  });
  // Reset flag setelah click selesai
  historyContainer.addEventListener('click', () => {
    setTimeout(() => (clickingDelete = false), 0);
  });

  const toggleContainers = () => {
    campaignButton.style.display = 'none';
    mobileNav.style.display = 'none';
    const query = searchInput.value.trim();
    if (query === '') {
      historyContainer.style.display = 'block';
    } else {
      historyContainer.style.display = 'none';
    }
  };

  searchInput.addEventListener('focus', toggleContainers);
  searchInput.addEventListener('input', toggleContainers);

  searchInput.addEventListener('blur', function() {
    setTimeout(() => {
      if (clickingDelete) return;
      historyContainer.style.display = 'none';
      campaignButton.style.removeProperty('display');
      mobileNav.style.removeProperty('display');
    }, 200);
  });
});


document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.querySelector('.search-bar__input');
  const collectionsContainer = document.querySelector('.custom-search_collections');
  const collectionsList = document.querySelector('.custom-search_collections__list');
  
  if (!searchInput || !collectionsContainer || !collectionsList) {
    console.error('Elemen untuk pencarian koleksi tidak ditemukan.');
    return;
  }

  searchInput.addEventListener('input', function() {
    const searchTerm = this.value.toLowerCase().trim();
    collectionsList.innerHTML = '';

    if (searchTerm.length === 0) {
      collectionsContainer.style.display = 'none';
      return;
    }

    const matchedCollections = window.searchableCollections.filter(function(collection) {
      return collection.title.toLowerCase().includes(searchTerm);
    });

    const limitedCollections = matchedCollections.slice(0, 6);

    if (limitedCollections.length > 0) {
      collectionsContainer.style.display = 'block';
      limitedCollections.forEach(function(collection) {
        const item = document.createElement('a');
        item.href = collection.url;
        item.className = 'collection-result-item';
        item.innerHTML = `
          <h4>${collection.title}</h4>
        `;
        collectionsList.appendChild(item);
      });
    } else {
      collectionsContainer.style.display = 'none';
    }
  });
});